module.exports = __webpack_public_path__ + "static/media/cc.cf30ad1f.svg";